<template>
  <div>
    <RefundHeader :img_header="header_image" header="เมนูรับคืนสินค้า" link_back="sell/all"/>
    <MenuRefund/>
    <Refund_process_success/>
  </div>
</template>

<script>
import RefundHeader from "@/components/admin/sell/refund_product/header_refund/RefundHeader";
import HeaderImage from "@/assets/return_refund.png";
import MenuRefund from "@/components/admin/sell/refund_product/menurefund/MenuRefund";
import Refund_process_success from "@/components/admin/sell/refund_product/Refund_process_success";
export default {
  name: "RefundProcessSuccess",
  components: {
    Refund_process_success,
    MenuRefund,
    RefundHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
